import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import {
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText
} from '@material-ui/core';
import RTVAvatar from '../RTVAvatar';

const styles = theme => ({
  primaryText: {
    divider: {
      borderBottomColor: fade(theme.palette.primary.main, 0.2)
    },
    fontWeight: 500
  },
  textLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

const PromotionTranslate = promotionType => {
  switch (promotionType) {
    case 'TWO_FOR_ONE':
      return '2x1';
    case 'THREE_FOR_TWO':
      return '3x2';
    case 'TWENTY_PERCENT':
      return '20% off';
    case 'THIRTY_PERCENT':
      return '30% off';
    case 'FORTY_PERCENT':
      return '40% off';
    case 'FREE_SHIPPING':
      return 'Envío gratis';
    case 'DISCOUNT_PRODUCTS':
      return 'Descuento en productos';
    default:
      return 'Promocion Desconocida';
  }
};

const MyPromotion = ({ notification, key, classes, type, noBorder }) => (
  <ListItem
    key={key}
    alignItems="flex-start"
    divider={!noBorder}
    classes={{
      divider: classes.divider
    }}
  >
    <ListItemAvatar>
      <Link to={`/vestidor/${notification.promotion.user.username}`}>
        <RTVAvatar
          src={
            notification.promotion.user.media
              ? notification.promotion.user.media.default_small ||
                notification.promotion.user.media.user_small
              : null
          }
          alt="avatar"
        />
      </Link>
    </ListItemAvatar>
    <ListItemText
      primary={
        <Typography className={classes.primaryText}>
          <Link
            to={`/vestidor/${notification.user.username}`}
            className={classes.textLink}
          >
            {notification.user.username}
          </Link>
        </Typography>
      }
      secondary={
        <>
          <Typography color="textPrimary">
            comenzó una nueva promoción{' '}
            {PromotionTranslate(notification.promotion.type)} en su vestidor
          </Typography>
          {notification.timePassedString}
        </>
      }
    />
  </ListItem>
);

export default withStyles(styles)(MyPromotion);
